import { render, staticRenderFns } from "./StatsQuery.vue?vue&type=template&id=8daa74d0&"
import script from "./StatsQuery.vue?vue&type=script&lang=js&"
export * from "./StatsQuery.vue?vue&type=script&lang=js&"
import style0 from "./StatsQuery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StatsQuery.vue"
export default component.exports